import React from 'react';

function Heart(props: object) {
  return (
    <svg
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.965 15.6072C9.71 15.6972 9.29 15.6972 9.035 15.6072C6.86 14.8647 2 11.7672 2 6.51721C2 4.19971 3.8675 2.32471 6.17 2.32471C7.535 2.32471 8.7425 2.98471 9.5 4.00471C10.2575 2.98471 11.4725 2.32471 12.83 2.32471C15.1325 2.32471 17 4.19971 17 6.51721C17 11.7672 12.14 14.8647 9.965 15.6072Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default Heart;
